<template>
  <v-container>
    <v-container>
      <v-card>
        <v-card-title>Create Team</v-card-title>
        <TeamEditComponent
          :team="team"
          :isCreate="true"
          :allow-close="false"
          @teamEditComplete="handleTeamComplete"
          @snack="throwSnack">
        </TeamEditComponent>
      </v-card>
    </v-container>
  </v-container>
</template>

<script setup lang="ts">
import TeamEditComponent from '@/components/teams/TeamEditComponent.vue';
import { ITeamDTO, TeamDTO } from '@/dtos';
import { useSnack } from '@/helpers';
import { SNACKSTATUS } from '@/stores/util';
import { ref } from 'vue';
import { useRouter } from 'vue-router';

const router = useRouter();
const emit = defineEmits<{
  (e: 'snack', objType: string, snackType: SNACKSTATUS, err?: string): void;
}>();
const { throwSnack } = useSnack(emit);
const team = ref<ITeamDTO>(new TeamDTO());

const handleTeamComplete = async () => {
  router.push({ name: 'AdminTeamListing' });
};
</script>
